// extracted by mini-css-extract-plugin
export default {"overflow":"ResultCard_overflow__tbhq0"};